var slideshowAnimations = function (el, clickIndex = null, direction = null) {
  var $this = el,
    $items = $this.querySelector('.coto_slide-items'),
    $slides = $this.querySelectorAll('.coto_slide'),
    $currentSlide = $this.querySelector('.current-slide'),
    $nextSlide = $currentSlide.nextElementSibling,
    index = Array.prototype.indexOf.call($items.children, $nextSlide),
    currIndex = Array.prototype.indexOf.call($items.children, $currentSlide),
    slideLength = $slides.length,
    hasNavigation = $this.classList.contains('coto_slide-controls'),
    hasPagination = $this.classList.contains('coto_slide-pagination'),
    //isCarousel = $this.classList.contains('coto_carousel'),
    startingPosition = '100%',
    endingPosition = '-100%';

  if ($nextSlide == null && clickIndex == null && direction == null) {
    $nextSlide = $slides[0];
    index = 0;
    if (direction != null) {
      index = slideLength;
    }
  }

  if (clickIndex != null || direction != null) {
    if (clickIndex != null) {
      index = clickIndex;
      $nextSlide = $slides[index];
    } else {
      if (direction == 'left') {
        $nextSlide = $currentSlide.previousElementSibling;
        index = Array.prototype.indexOf.call($items.children, $nextSlide);

        if ($nextSlide == null) {
          index = slideLength - 1;
          $nextSlide = $slides[slideLength - 1];
        }
      } else {
        if ($nextSlide == null) {
          index = 0;
          $nextSlide = $slides[0];
        }
      }
    }

    if (index < currIndex || direction == 'left') {
      startingPosition = '-100%';
      endingPosition = '100%';
    }
  }

  if (hasNavigation || (hasPagination && clickIndex == null)) {
    var $slideshowNav = $this.querySelector('.coto_slideshow-nav'),
      $slideshowNavButton = $slideshowNav.getElementsByTagName('button');

    $slideshowNav.querySelector('.active').classList.remove('active');
    $slideshowNavButton[index].classList.add('active');

    if (document.querySelector('.product-thumbnails')) {
      var $productThumbnails = document.querySelector('.product-thumbnails');

      $productThumbnails.querySelector('.active').classList.remove('active');
      $productThumbnails
        .getElementsByTagName('figure')
        [index].classList.add('active');
    }
  }

  if (isCarousel) {
    //$nextSlide.classList.add('next-slide');
    //$nextSlide.style.left = startingPosition;
    //setTimeout(function () {
    //$nextSlide.style['transition'] = 'left 0.5s ease-out';
    //$currentSlide.style['transition'] = 'left 0.5s ease-out';
    //$currentSlide.style.left = endingPosition;
    // $nextSlide.style.left = 0;
    // }, 10);
    //setTimeout(function () {
    //$currentSlide.classList.remove('current-slide');
    //$currentSlide.removeAttribute('style');
    //$nextSlide.classList.remove('next-slide');
    //$nextSlide.classList.add('current-slide');
    //$nextSlide.removeAttribute('style');
    //}, 500);
  } else {
    $currentSlide.classList.add('slide-out');
    $nextSlide.classList.add('next-slide');
    var slideVid = document.querySelector('.slide-vid');

    if (slideVid) {
      //console.log('there is a video');
      //if the next slide has a video in it, then start playing it
      if ($nextSlide.contains(slideVid)) {
        slideVid.play();
        // Otherwise stop the video
      } else {
        slideVid.pause();
        slideVid.currentTime = 0;
      }
    }

    setTimeout(function () {
      $currentSlide.classList.remove('slide-out');
      $currentSlide.classList.remove('current-slide');
      $nextSlide.classList.remove('next-slide');
      $nextSlide.classList.add('current-slide');
    }, 500);
  }
};

module.exports = slideshowAnimations;
